import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useChangePassword } from "../../Controllers/AuthController";
import PasswordInput from "../Inputs/PasswordInput";
import ContainedButton from "../Buttons/ContainedButton";

const ChangePassword = () => {
  const [validation, setValidation] = useState({
    hasNumber: false,
    hasSymbol: false,
    isValidLength: false,
  });

  const { control, formState, handleSubmit, watch } = useForm({
    mode: "onChange",
    defaultValues: {
      newPassword: "",
      confirmPassword: "",
    },
  });

  const { isValid, errors } = formState;
  const { mutateAsync: changePassword, isPending: isLoading } =
    useChangePassword();

  const watchedNewPassword = watch("newPassword");
  const watchedConfirmPassword = watch("confirmPassword");

  // Update validation when password changes
  useEffect(() => {
    if (watchedNewPassword) {
      const hasNumber = /\d/.test(watchedNewPassword);
      const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/.test(watchedNewPassword);
      const isValidLength = watchedNewPassword.length >= 8;

      setValidation({ hasNumber, hasSymbol, isValidLength });
    }
  }, [watchedNewPassword]);

  // Form validation rules
  const validationRules = {
    newPassword: {
      required: "New password is required",
      minLength: {
        value: 8,
        message: "Password must be at least 8 characters",
      },
      validate: (value) => {
        const hasNumber = /\d/.test(value);
        const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/.test(value);
        if (!hasNumber) return "Password must contain at least one number";
        if (!hasSymbol) return "Password must contain at least one symbol";
        return true;
      },
    },
    confirmPassword: {
      required: "Please confirm your password",
      validate: (value) => {
        if (value !== watchedNewPassword) return "Passwords do not match";
        return true;
      },
    },
  };

  const onSubmit = async (data) => {
    try {


      await changePassword({
        new_password: data.newPassword,
        new_password_confirmation: data.confirmPassword,
      });


      toast.success("Password changed successfully!");

      // Reset form
      // This would require using reset from react-hook-form
    } catch (error) {
      console.error("Change password error:", error);
      toast.error(
        error?.response?.data?.message ||
          "An error occurred. Please try again later.",
      );
    }
  };

  return (
    <div>
      <div className="profile-container">
        <h1 className="setting-header text-heading-h3 mb-3 mb-md-4">
          Change Password
        </h1>
        <div
          className="change-password-content"
          style={{ width: "100%", maxWidth: "100%" }}
        >
          <form
            onSubmit={handleSubmit(onSubmit)}
            style={{ maxWidth: "100%", width: "100%" }}
          >
            <div className="gap-4 d-flex ">
              <div style={{ width: "40%" }}>
                <div className="textfield-1" style={{ position: "relative" }}>
                  <PasswordInput
                    name="newPassword"
                    control={control}
                    label="New Password"
                    placeholder=""
                    rules={validationRules.newPassword}
                    className="text-body-b2"
                  />
                  {errors.newPassword && (
                    <p className="text-danger small mt-1">
                      {errors.newPassword.message}
                    </p>
                  )}
                </div>
                <div
                  className="textfield-1 mt-4"
                  style={{ position: "relative" }}
                >
                  <PasswordInput
                    name="confirmPassword"
                    control={control}
                    label="Confirm New Password"
                    placeholder=""
                    rules={validationRules.confirmPassword}
                    className="text-body-b2"
                  />
                  {errors.confirmPassword && (
                    <p className="text-danger small mt-1">
                      {errors.confirmPassword.message}
                    </p>
                  )}
                </div>
              </div>
              <div>
                <div className="change-password-error-container">
                  <h1 className="text-body-b1" style={{ marginTop: "0px" }}>
                    Password must contain:
                  </h1>
                  <span
                    style={{
                      textDecoration: validation.hasNumber
                        ? "line-through"
                        : "none",
                      color: validation.hasNumber ? "#5BC67D" : "#D0D8DF",
                    }}
                  >
                    At least 1 number (0-9)
                  </span>
                  <span
                    style={{
                      textDecoration: validation.hasSymbol
                        ? "line-through"
                        : "none",
                      color: validation.hasSymbol ? "#5BC67D" : "#D0D8DF",
                    }}
                  >
                    At least 1 symbol (e.g., !, @, #, $, etc.)
                  </span>
                  <span
                    style={{
                      textDecoration: validation.isValidLength
                        ? "line-through"
                        : "none",
                      color: validation.isValidLength ? "#5BC67D" : "#D0D8DF",
                    }}
                  >
                    At least 8 characters
                  </span>
                </div>
              </div>
            </div>

            <div className="mt-3 mt-md-0">
              <ContainedButton
                type="submit"
                isFormValid={isValid}
                isLoading={isLoading}
                className="text-body-b1 btn-1 btn-1-primary"
                style={{
                  maxWidth: "240px",
                  width: "100%",
                  padding: "6px 20px",
                }}
              >
                {isLoading ? "Changing..." : "Change Password"}
              </ContainedButton>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
